import {CSSProperties} from "react"

export default function HouseMehrfamilienEckhaus(props: {
  selected_menu_item: string;
  onEnterElement: (id: string) => void;
  onLeaveElement: (id: string) => void;
  onClickElement: (id: string) => void;
  element_styling_function: (id: string) => CSSProperties;
  icon_styling_function: (id: string) => CSSProperties;
  outline_styling_function: (id: string) => CSSProperties;
}) {
  const enter_element = props.onEnterElement;
  const leave_element = props.onLeaveElement;
  const click_element = props.onClickElement;
  const element_styling_function = props.element_styling_function;
  const icon_styling_function = props.icon_styling_function;
  const outline_styling_function = props.outline_styling_function; 

  return (  
    <>
  {/*BEGIN SVG*/}
    <svg  viewBox="0 0 3000 3000">
  <defs>
    <style>{`
      .cls-1, .cls-2 {
        fill: none;
      }

      .cls-3 {
        fill: #f29400;
      }

      .cls-4 {
        fill: #a67359;
      }

      .cls-2 {
        stroke: #dfe6ee;
        stroke-width: 3px;
      }

      .cls-5 {
        fill: #f19200;
      }

      .cls-6 {
        fill: #5961a6;
      }

      .cls-7 {
        fill: #dfe6ee;
      }

      .cls-8 {
        fill: #0df2c9;
      }

      .cls-9 {
        isolation: isolate;
      }

      .cls-10 {
        fill: #40a8bf;
      }

      .cls-11 {
        clip-path: url(#clippath-17);
      }

      .cls-12 {
        clip-path: url(#clippath-11);
      }

      .cls-13 {
        clip-path: url(#clippath-16);
      }

      .cls-14 {
        clip-path: url(#clippath-18);
      }

      .cls-15 {
        clip-path: url(#clippath-10);
      }

      .cls-16 {
        clip-path: url(#clippath-15);
      }

      .cls-17 {
        clip-path: url(#clippath-13);
      }

      .cls-18 {
        clip-path: url(#clippath-14);
      }

      .cls-19 {
        clip-path: url(#clippath-12);
      }

      .cls-20 {
        mix-blend-mode: multiply;
      }

      .cls-21 {
        fill: #f2b00d;
      }

      .cls-22 {
        clip-path: url(#clippath-1);
      }

      .cls-23 {
        clip-path: url(#clippath-3);
      }

      .cls-24 {
        clip-path: url(#clippath-4);
      }

      .cls-25 {
        clip-path: url(#clippath-2);
      }

      .cls-26 {
        clip-path: url(#clippath-7);
      }

      .cls-27 {
        clip-path: url(#clippath-6);
      }

      .cls-28 {
        clip-path: url(#clippath-9);
      }

      .cls-29 {
        clip-path: url(#clippath-8);
      }

      .cls-30 {
        clip-path: url(#clippath-5);
      }

      .cls-31 {
        fill: #fff;
      }

      .cls-32 {
        fill: #26d93b;
      }

      .cls-33 {
        fill: #f29200;
      }

      .cls-34 {
        fill: #f19000;
      }

      .cls-35 {
        fill: #f29404;
      }

      .cls-36 {
        fill: #f25e0d;
      }

      .cls-37 {
        clip-path: url(#clippath);
      }

      .cls-38 {
        fill: #d9e51a;
      }
    `}</style>
    <clipPath id="clippath">
      <rect className="cls-1" x="385.37" y="17.84" width="2302.21" height="2650.63"></rect>
    </clipPath>
    <clipPath id="clippath-1">
      <rect className="cls-1" x="385.37" y="17.84" width="2302.21" height="2650.63"></rect>
    </clipPath>
    <clipPath id="clippath-2">
      <rect className="cls-1" x="379.54" y="12.2" width="2316.87" height="589.13"></rect>
    </clipPath>
    <clipPath id="clippath-3">
      <rect className="cls-1" x="379.54" y="50.83" width="2288.81" height="2098.39"></rect>
    </clipPath>
    <clipPath id="clippath-4">
      <rect className="cls-1" x="667.06" y="604.08" width="99.31" height="999.46"></rect>
    </clipPath>
    <clipPath id="clippath-5">
      <rect className="cls-1" x="503.67" y="628.94" width="2021.07" height="1482.84"></rect>
    </clipPath>
    <clipPath id="clippath-6">
      <rect className="cls-1" x="1435.31" y="1309.57" width="291.88" height="1089.93"></rect>
    </clipPath>
    <clipPath id="clippath-7">
      <rect className="cls-1" x="389.79" y="1849.72" width="1976.43" height="830.76"></rect>
    </clipPath>
    <clipPath id="clippath-8">
      <rect className="cls-1" x="797.66" y="85.04" width="898.95" height="355.15"></rect>
    </clipPath>
    <clipPath id="clippath-9">
      <rect className="cls-1" x="1681.02" y="191.57" width="770.64" height="303.38"></rect>
    </clipPath>
    <clipPath id="clippath-10">
      <rect className="cls-1" x="2025.09" y="921.37" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-11">
      <rect className="cls-1" x="1537.98" y="83.88" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-12">
      <rect className="cls-1" x="1182.56" y="198.31" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-13">
      <rect className="cls-1" x="2040.82" y="282.45" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-14">
      <rect className="cls-1" x="606.25" y="1042.99" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-15">
      <rect className="cls-1" x="1050.49" y="2238.85" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-16">
      <rect className="cls-1" x="1050.49" y="2238.85" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-17">
      <rect className="cls-1" x="1050.49" y="2238.85" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-18">
      <rect className="cls-1" x="1598.8" y="1357.68" width="121.62" height="586.33"></rect>
    </clipPath>
  </defs>
  
  <g className="cls-9">
    <g id="MFH">
      <g id="interaktive_flaechen">
        <polygon id="fassade" className="cls-36" points="627.57 65.38 376.71 583.88 383.09 1862.54 710.73 2043.96 759.39 2035.93 761.75 2027.43 733.4 2010.42 733.87 1987.27 757.26 1980.65 759.39 1072.86 980.49 1091.52 1726.71 1064.35 1725.53 2018.92 1759.54 2032.62 1759.54 2142.23 2876.39 1887.11 2865.06 705.06 2868.36 649.31 2876.87 603.02 984.74 484.91 627.58 65.38 627.57 65.38" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={element_styling_function("fassade")}></polygon>
        <polygon id="dach" className="cls-8" points="637.7 17.84 376.91 564.21 383.06 579.1 633.92 54.92 988.96 477.05 2670.62 582.17 2679.12 587.84 2882.74 600.36 2878.96 317.6 637.7 17.84" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={element_styling_function("dach")}></polygon>
        <polygon id="photovoltaik" className="cls-38" points="803.48 87.99 1402.06 165.95 1678.44 419.65 1674.19 429.57 1043.01 378.07 803.48 87.99" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={element_styling_function("photovoltaik")}></polygon>
        <polygon id="solarthermie" className="cls-4" points="1701.12 204.21 1705.37 215.55 1997.34 457.44 2440.96 497.6 2445.21 489.1 2133.4 256.66 1701.12 204.21" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={element_styling_function("solarthermie")}></polygon>
        <polygon id="lueftung" className="cls-6" points="774.19 1594.61 717.5 1605.95 685.84 1588.94 689.15 616.66 726 612.4 728.83 1098.07 774.19 1101.38 770.88 1146.73 728.83 1146.73 725.53 1567.68 772.77 1564.84 774.19 1594.61" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={element_styling_function("lueftung")}></polygon>
        <g id="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={element_styling_function("keller")}>
          <g className="cls-37">
            <path className="cls-10" d="M397.89,1861.07l-1.18,95.67,273.31,178.82,2.13,308.03,310.39,224.88,774.8-212.13,13.94,8.03,250.87-73.7-6.38-308.5-240.24,53.39-4.25-106.54-31.89-17.01-2.13-57.4-716.93,144.57c-122.84-63.78-248.27-125.43-248.27-125.43l-21.26,8.74-2.13,22.68,29.76,23.86-52.91,12.76-327.64-180.71Z"></path>
          </g>
        </g>
        <g id="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={element_styling_function("fenster")}>
          <g className="cls-22">
            <path className="cls-32" d="M514.35,900.12l70.87,2.36-.94-229.13-65.67,5.67-4.25,221.1ZM584.27,1119.33l-65.67-7.09-4.25,215.9,69.92,18.9v-227.72ZM514.35,1757.13l70.87,33.07v-229.61l-66.61-23.15-4.25,219.68ZM748.2,905.32l111.97,2.83-.95-262.2-103.94,10.39-7.09,248.98ZM1124.27,908.62h216.85v-264.09l-215.43-8.03-1.42,272.13ZM1695.45,904.37l1.42-245.2-188.5-8.5-1.42,255.12,188.5-1.42ZM1882.53,1585.63v240l137.48-24.09s1.42-232.91-1.89-235.28c-3.31-2.36-135.59,19.37-135.59,19.37M1883.95,902.95h137.48l-2.83-232.44-134.65-3.31v235.75ZM1883.95,1367.84l137.48-12.76-1.42-232.44-136.06,5.67v239.53ZM2018.6,2075.08l2.83-77.95-105.35,22.68-3.78,79.37,106.3-24.09ZM2142.85,900.12h119.53v-218.27l-121.89-5.67,2.36,223.94ZM2140.49,1341.85l121.89-11.34-.47-220.63-122.83,5.2,1.42,226.77ZM2140.49,1778.39l123.31-22.68v-221.1l-126.14,17.01,2.83,226.77ZM2165.53,2039.18l98.27-23.62-1.42-70.87-94.96,21.26-1.89,73.23ZM2520.33,1933.35V691.77l-154.49-7.09-4.25,1281.26,158.74-32.6Z"></path>
          </g>
        </g>
        <path id="heizung" className="cls-21" d="M1533.16,2118.55l-78.66,16.77,2.13,192.99,164.65,70.63,101.1-12.76,6.61-381.02-240.47,47.24-2.13,20.79,46.77,19.61v25.75ZM1740.33,1061.7l-745.04,27.64-223.23-19.61,2.13,899.76,246.14,129.68,716.93-144.57,3.07-892.91Z" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}></path>
      </g>
      <g id="Rahmen">
        <g id="dach_rahmen" style={outline_styling_function("dach")}>
          <g className="cls-25">
            <path className="cls-3" d="M388.65,601.33l-9.11-35.87,1.08-2.28L642.18,12.2l5.05.67,1577.15,208.58,1.46,1.08,470.57,348.45-14.15,20.39-3.93-.24-1677.4-102.05-3.02-.18L647.87,68.75l-259.22,532.58ZM1001.36,482.09l1677.4,102.05,8.03-11.57-465.12-344.41L646.32,19.81l-259.37,546.38,3.78,14.88L646.32,55.95l355.04,426.14Z"></path>
          </g>
        </g>
        <g id="fassade_rahmen" style={outline_styling_function("fassade")}>
          <g className="cls-23">
            <path className="cls-3" d="M1762.39,2149.22v-113.71l-34.02-13.7,1.18-952.03-739.38,26.92-71.92-6.07-142.03-11.99-2.12,905.48-23.48,6.64-.28,13.91,29.44,17.66-4.99,17.94-55.47,9.16-2.13-1.18-331.23-183.41-6.41-1284.38.71-1.46L635.79,50.84l6.96,8.17,355.24,417.26,1670.37,103.45v57.49l-19.14,2.13-2.12,1302.51-5.39,1.26-875.01,205.1-4.3,1.01ZM1735.37,2017.09l34.02,13.7v109.61h0s870.71-204.1,870.71-204.1l2.12-1303.23,19.13-2.13v-44.65l-1666.77-103.23-.96-1.13L637.42,63.54h0s-250.87,518.5-250.87,518.5l6.38,1278.66h0l327.64,181.42,48.66-8.03,2.36-8.5-28.35-17.01.47-23.15,23.39-6.62,2.13-907.79,221.12,18.66,746.21-27.17v3.63s-1.18,950.93-1.18,950.93h0Z"></path>
          </g>
        </g>
        <g id="lueftung_rahmen" style={outline_styling_function("lueftung")}>
          <g className="cls-24">
            <path className="cls-3" d="M701.83,1603.53l-34.77-12.64.34-48.6,41.86,13.95,57.11-3.7v43.73l-64.54,7.26ZM674.09,1586l28.58,10.39,56.69-6.38v-30l-51.02,3.31-34.02-11.34-.24,34.02ZM764.01,1133.79h-95.36l.69-46.6,39.07,2.61,55.61,1.88v42.11ZM675.75,1126.79h81.26v-28.35s-49.01-1.66-49.01-1.66l-31.77-2.12-.47,32.13ZM667.33,655.65v-45.24l47.72-6.34.34,48.57-48.06,3ZM674.33,616.55v31.65l34.01-2.13-.24-34.02-33.78,4.49Z"></path>
          </g>
        </g>
        <g id="fenster_rahmen" style={outline_styling_function("fenster")}>
          <g className="cls-30">
            <path className="cls-3" d="M1905.51,2111.78v-94.11l120.3-25.66v88.23l-120.3,31.54ZM1912.51,2023.34v79.37l106.3-27.87v-74.17l-106.3,22.68ZM2156.38,2049.12v-87.64l111.8-24.3v86.56l-103.25,23.44-.78-3.41.78,3.41-8.55,1.94ZM2163.38,1967.12v73.23l97.8-22.21v-72.28l-97.8,21.26ZM2350.39,1978.96l.17-9.13,5.78-320.55,165.58-25.28-1.5,321.63-15.74-5.25-154.29,38.57ZM2363.22,1655.31l-5.67,314.65,147.4-36.85,8.5,2.83,1.42-303.78-151.65,23.15h0ZM1874.28,1833.83l1.5-254.18,147.15-17.74,1.5,243.77-5.75,1.08-144.4,27.07ZM1882.75,1585.86l-1.42,239.53h0l136.06-25.51-1.42-230.08-133.23,16.06h0ZM588.08,1802.38l-82.91-39.18,1.51-234.05,83.43,30.08-2.02,243.15ZM512.2,1758.77h0s68.98,32.6,68.98,32.6h0s1.89-227.25,1.89-227.25l-69.45-25.04-1.42,219.68ZM2129.45,1788.52v-241.42l137.25-17.35,1.51,231.97-138.76,26.8ZM2136.45,1553.26v226.77l124.73-24.1-1.42-218.27-123.31,15.59ZM2354.77,1635.08l1.48-321.08,167.08-16.5-.04,7.76-1.45,305.07-167.08,24.75ZM2363.22,1320.35h0s-1.42,306.61-1.42,306.61l153.07-22.68,1.42-299.05h0l-153.07,15.12ZM1875.75,1376.8v-254.02l148.69-6.26-.05,7.35-1.45,237.28-147.19,15.66ZM1882.75,1129.48v239.53l133.23-14.17,1.42-231.02-134.65,5.67ZM588.65,1358.1l-84.97-20.96.11-5.59,4.4-227.12,80.46,11.41v242.26ZM510.78,1331.69l70.87,17.48v-227.24l-66.61-9.45-4.25,219.21ZM2130.87,1351.2v-241.16l135.84-6.32,1.5,234.32-137.35,13.15ZM2137.87,1343.5h0s123.31-11.81,123.31-11.81l-1.42-220.63-121.89,5.67v226.77h0ZM2356.19,1300.15l.04-7.71,1.45-305.94,167.04-2.06v300.25l-168.52,15.46ZM2364.64,993.42l-1.42,299.06h0l154.49-14.17v-286.77l-153.07,1.89ZM2356.22,959.09v-280.55l168.53,7.73-1.49,267.15-167.03,5.67ZM2363.22,685.86v265.98l153.07-5.2,1.42-253.7-154.49-7.09ZM1116.06,919.28v-290.34l227.98,10.06,1.49,276.26-229.47,4.02ZM1123.06,636.26v275.91s215.43-3.78,215.43-3.78l-1.42-262.68-214.02-9.45ZM866.04,915.57l-121.78-3.21v-261.31l119.29-9.63,2.5,274.14ZM751.25,905.55l107.72,2.83h0s-2.36-259.37-2.36-259.37l-105.35,8.5v248.03ZM1701.25,913.49h-202.99l.5-268.91,202.49,7.61v261.3ZM1505.27,906.49h188.98v-247.56s-188.5-7.09-188.5-7.09h0s-.47,254.65-.47,254.65ZM1874.33,909.79v-249.57l150.11,4.69-1.5,243.32-148.6,1.56ZM1881.33,667.44v235.28l134.65-1.42,1.42-229.61-136.06-4.25ZM2268.18,908.29h-137.31v-239.6l137.31,4.73v234.87ZM2137.87,901.29h123.31v-221.1l-123.31-4.25v225.35ZM590.11,908.29h-84.02l2-233.12,80.51-6.85,1.51,239.97ZM513.14,901.29h69.92l-1.42-225.35-66.61,5.67-1.89,219.69Z"></path>
          </g>
        </g>
        <g id="heizung_rahmen" style={outline_styling_function("heizung")}>
          <g className="cls-27">
            <path className="cls-3" d="M1652.7,2399.49c-1.9,0-3.85-.05-5.85-.15-45.31-2.23-68.06-23.72-69.01-24.63l-2.13-2.07v-30.68l-71.11,19.14-57.92-31.21.7-47.93-7.95-2.89.92-20.33-5.03-1.37.85-56.19,4.9-2.8v-74.54l77.95-14.17v-16.69l-46.93-19.91,1.06-31.31,92.66-19.56,23.47,10.75-3.51,59.04,5.6,1.97c6.38-1.91,23.64-6.71,40.38-8.11,6.59-.55,12.04-.81,16.26-.76v-60.84l-30.59-12.83,75.26-16.85.49,97.28c7.75,3,18.68,8.76,20.45,17.83,1.7,8.76-.18,219.35-.58,261.48l-.02,2.08-1.16,1.73c-.69,1.04-16.84,24.51-59.14,24.51ZM1582.71,2369.68h0c.87.84,21.78,20.58,64.49,22.68,42.73,2.11,58.18-20.3,58.82-21.26h0c.87-93.06,2.01-252.56.71-260.09-.92-4.73-7.73-9.75-18.21-13.4l-2.33-.81-.47-93.49-45.35,10.16h0l14.65,6.14v72.88l-3.74-.26c-4.12-.29-10.66-.08-18.93.61-17.13,1.43-34.96,6.61-40.01,8.16l-1.1.34-12.75-4.49,3.54-59.53-17.01-7.8h0s-85.04,17.95-85.04,17.95l-.71,21.02,46.77,19.84v27.17l-77.95,14.17v72.75l-4.96,2.84-.71,46.77,5.2,1.42-.94,20.78h0l7.79,2.83-.71,48.66,51.73,27.87,77.25-20.79v36.85ZM1727.19,1955.64l-50.57-22.04-.45-7.25-70.69-25.62v-139.35l16.65-4.16,1.87.58,88.14,27.32-7.02,16.84-6.82.36-1.29,115.61,30.18,11.32v26.41ZM1683.33,1928.89l36.85,16.06v-10.87l-30.24-11.34,1.42-127.09,8.98-.47,2.36-5.67-80.79-25.04-9.45,2.36v128.98l70.39,25.51.47,7.56h0ZM1727.19,1489.34l-50.53-11.66-.47-7.9-71.26-14.73,1.55-144.01,20-1.48,82.39,13.47-2.14,22.49-9.79.44v112.18l30.24,8.03v23.16ZM1683.34,1472.04l36.85,8.5v-8.98l-30.24-8.03v-124.25l10.39-.47.94-9.92-75.12-12.28h0s-12.75.94-12.75.94l-1.42,131.81,70.87,14.65.47,8.03Z"></path>
          </g>
        </g>
        <g id="keller_rahmen" style={outline_styling_function("keller")}>
          <g className="cls-26">
            <path className="cls-3" d="M974.26,2680.48l-244.95-189.04-12.14,1.4-2.2-1.57-58.19-41.78-.47-311.37-131.84-76.6-.82-1.04c-.37-.46-38.42-48.37-50.96-63.7-4.15-5.08-7.64-10.81-11.02-16.35-6.72-11.05-13.08-21.49-22.37-22.2-17.4-1.34-26.79-9.59-32.4-14.52-1.12-.99-2.09-1.84-2.91-2.46-6.18-4.63-8.92-7.86-9.21-8.21l-1.51-1.81-3.47-81.51,330.42,184.86,34.77-6.95-20.4-9.66,1.28-38.57,31.05-5.7,2.13,1.1,246.79,127.84,720.28-145.95,22.01,10.01-1.98,35.7-13.86,2.77v5l27.57,10.34,596.38-124.72-3.35,90.32-4.6,1.54c-13.28,4.43-29.23,11.78-31.82,15.67-6.37,9.56-32.79,15.94-44.46,18.35l-26.83,15.06-.96.23-231.35,54.49-2.83,304.42-4.98,1.46-248.89,72.95-18.47-7.11-757.37,211.95-16.05,5.35ZM731.33,2484.16l244.25,188.5,12.76-4.25,759.69-212.6,18.43,7.09,246.61-72.28,2.83-304.72,2.67-.63,234.03-55.12,26.92-15.12.54-.11c17.42-3.55,36.72-9.71,40.57-15.48,5.6-8.4,35.13-18.33,35.43-18.42h0s2.83-76.54,2.83-76.54l-589.61,123.31-34.02-12.75v-15.59l14.17-2.83,1.42-25.51-15.59-7.09-720.47,145.98-248.98-128.98-23.15,4.25-.94,28.35,26.93,12.76v5.67l-49.61,9.92-321.73-180,2.83,66.61c.06.07,2.5,2.94,8.03,7.09,1.04.78,2.15,1.76,3.33,2.8,5.59,4.91,13.24,11.63,28.32,12.79,12.87.99,20.47,13.47,27.81,25.54,3.25,5.34,6.61,10.86,10.45,15.56,12.55,15.34,50.55,63.18,51.02,63.78h0l134.17,77.95.47,311.81,55.27,39.69h0s12.28-1.42,12.28-1.42Z"></path>
          </g>
        </g>
        <g id="photovoltaik_rahmen" style={outline_styling_function("photovoltaik")}>
          <g className="cls-29">
            <path className="cls-3" d="M1685.33,440.19l-634.9-53.03-1.88-2.24-250.89-299.88,612.26,74.7,1.65,1.52,285.04,262.01-11.28,16.92ZM1053.92,380.43l627.88,52.44h0s5.67-8.5,5.67-8.5l-280.63-257.95-592.44-72.28h0s239.53,286.3,239.53,286.3h0Z"></path>
          </g>
        </g>
        <g id="solarthermie_rahmen" style={outline_styling_function("solarthermie")}>
          <g className="cls-28">
            <path className="cls-3" d="M2444.12,494.94l-450.37-35.97-1.73-1.48-311-265.93,452.87,54.98,1.49,1.1,316.28,233.73-7.54,13.56ZM1996.57,452.17l443.62,35.43h0s2.36-4.25,2.36-4.25l-311.34-230.08-428.03-51.97h0s293.38,250.87,293.38,250.87Z"></path>
          </g>
        </g>
      </g>
      <g id="Icons">
        <g id="fassade-2" data-name="fassade" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={icon_styling_function("fassade")}>
          <g>
            <g className="cls-15">
              <path className="cls-5" d="M2085.88,1042.99c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="cls-31" d="M2108.81,977.91v-22.89h-45.84v22.89h-19.53v29.33h84.88v-29.33h-19.53.02ZM2069.71,961.78h32.32v15.81h-32.32v-15.81ZM2050.2,1000.48v-15.81h32.28v15.81h-32.28ZM2121.56,1000.48h-32.28v-15.81h32.28v15.81Z"></path>
          </g>
        </g>
        <g id="dach-2" data-name="dach" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={icon_styling_function("dach")}>
          <g className="cls-12">
            <path className="cls-5" d="M1598.8,205.5c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          </g>
          <path className="cls-31" d="M1645.04,163.65l-16.6-41.02h-57.21l.07.18-15.45,37.08,6.24,2.59,12.82-30.75,12.93,31.92h57.21-.01ZM1623.89,129.38l11.13,27.5h-42.64l-11.13-27.5h42.64Z"></path>
        </g>
        <g id="photovoltaik-2" data-name="photovoltaik" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={icon_styling_function("photovoltaik")}>
          <g id="icon">
            <g className="cls-19">
              <path className="cls-5" d="M1243.38,319.92c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <polygon className="cls-31" points="1244.24 232.66 1259.98 232.66 1245.29 255.77 1265.61 255.77 1229.98 292.58 1242.3 266.94 1228.67 266.94 1244.24 232.66"></polygon>
          </g>
        </g>
        <g id="solarthermie-2" data-name="solarthermie" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={icon_styling_function("solarthermie")}>
          <g className="cls-17">
            <g>
              <path className="cls-5" d="M2101.64,404.06c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="cls-31" d="M2089.74,332.48c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.74,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.02Z"></path>
              <path className="cls-31" d="M2089.74,352.46c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
              <path className="cls-31" d="M2089.74,372.46c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
            </g>
          </g>
        </g>
        <g id="lueftung-2" data-name="lueftung" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
          <g id="lueftung-2" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
            <g className="cls-18">
              <g>
                <path className="cls-35" d="M667.07,1164.6c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="cls-31" d="M680.88,1082.7c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
                <path className="cls-31" d="M655.51,1126.29c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
                <path className="cls-31" d="M646.41,1091.8c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
                <path className="cls-31" d="M690,1117.16c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
              </g>
            </g>
          </g>
        </g>
        <g id="keller-2" data-name="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={icon_styling_function("keller")}>
          <g className="cls-16">
            <g>
              <g className="cls-13">
                <path className="cls-5" d="M1111.29,2360.47c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <path className="cls-31" d="M1142.51,2309.61h-62.44v-33.77l30.12-13.76,32.3,13.7v33.83h.02,0ZM1086.82,2302.85h48.93v-22.59l-25.45-10.79-23.47,10.72v22.66h-.01Z"></path>
              <rect className="cls-31" x="1080.06" y="2309.25" width="6.76" height="24.51"></rect>
              <rect className="cls-31" x="1135.75" y="2309.25" width="6.76" height="24.51"></rect>
              <rect className="cls-31" x="1080.43" y="2316.16" width="58.7" height="6.76"></rect>
              <g className="cls-11">
                <g className="cls-20">
                  <g>
                    <path className="cls-7" d="M1124.35,2254.82"></path>
                    <path className="cls-2" d="M1124.35,2254.82"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="fenster-2" data-name="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={icon_styling_function("fenster")}>
          <path className="cls-34" d="M2365.21,1506.78c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          <path className="cls-31" d="M2384.24,1472.81h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM2339.41,1479.57h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="fenster-3" data-name="fenster">
          <path className="cls-34" d="M1699.54,842.03c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          <path className="cls-31" d="M1718.57,808.06h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM1673.74,814.82h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="fenster-4" data-name="fenster">
          <path className="cls-34" d="M484.64,1370.36c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          <path className="cls-31" d="M503.67,1336.39h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM458.84,1343.15h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="heizung-2" data-name="heizung" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={icon_styling_function("heizung")}>
          <g className="cls-14">
            <g>
              <path className="cls-33" d="M1659.6,1944.03c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="cls-31" d="M1629.82,1866.21c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,1910.84c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1652.63,1866.21c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,1910.84c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1675.45,1866.21c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,1910.84c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1695.77,1866.21c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,1880.49c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
              <path className="cls-33" d="M1659.6,1479.3c33.59,0,60.82-27.23,60.82-60.8s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.8,60.82,60.8"></path>
              <path className="cls-31" d="M1629.82,1401.49c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,1446.12c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1652.63,1401.49c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,1446.12c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1675.45,1401.49c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,1446.12c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="cls-31" d="M1695.77,1401.49c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,1415.78c-5.81,0-10.52-4.73-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.73,10.52,10.52-4.71,10.52-10.52,10.52"></path>
            </g>
          </g>
          <path className="cls-33" d="M1659.61,2348.67c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          <path className="cls-31" d="M1629.83,2270.86c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.83,2315.49c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-31" d="M1652.64,2270.86c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.64,2315.49c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-31" d="M1675.46,2270.86c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.46,2315.49c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
          <path className="cls-31" d="M1695.78,2270.86c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.78,2285.14c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
        </g>
      </g>
    </g>
  </g>
</svg>
    {/*END SVG*/}
    <div className={"house-img mehrfamilieneckhaus-img"}></div>
  </>);
}
